import { cn } from '../../lib/utils';

export function StatsCard({ title, value, icon: Icon, trend, trendUp, className }) {
  return (
    <div className={cn(
      "bg-slate-900/50 border border-slate-800 rounded-sm p-5 backdrop-blur-sm",
      className
    )} data-testid={`stats-card-${title.toLowerCase().replace(/\s+/g, '-')}`}>
      <div className="flex items-start justify-between">
        <div>
          <p className="text-xs uppercase tracking-wider text-slate-500 font-medium mb-1">
            {title}
          </p>
          <p className="text-2xl font-bold text-white tabular-nums">
            {value}
          </p>
          {trend && (
            <p className={cn(
              "text-xs mt-1 font-medium",
              trendUp ? "text-green-400" : "text-red-400"
            )}>
              {trendUp ? '↑' : '↓'} {trend}
            </p>
          )}
        </div>
        {Icon && (
          <div className="p-2 bg-green-500/10 rounded-sm">
            <Icon className="w-5 h-5 text-green-400" />
          </div>
        )}
      </div>
    </div>
  );
}
